<mbp-modal id="select-item-modal" [modalTitle]="labels().modalTitle" [busy]="processing()"
  (close)="onClose()">
  <ng-container slot="modal-content">
    @if (itemsResource.isLoading()) {
      <mbp-loading-message [message]="labels().loadingMessage ?? 'general.loading'" type="fit-content" />
    } @else if (itemsResource.value().length === 0) {
      <mbp-no-content-message [message1]="labels().noDataMessage || ('general.noData' | translate)" type="fit-content" />
    } @else {
      <mbp-search [searchTerm]="searchText()" (searchTermChange)="onSearchChange($event)"
        [placeholder]="labels().searchPlaceholder"></mbp-search>
      @if (filteredItems().length === 0) {
        <mbp-no-content-message [message1]="labels().noDataMessage || ('general.noData' | translate)" type="fit-content" />
      } @else {
        <div class="select-item-list">
          @for (item of filteredItems(); track item.id) {
            <button type="button" class="select-item-card" [class.selected]="selectedItemId() === item.id"
              (click)="onSelectItem(item)">
              <span class="select-item-text">{{ item.text }}</span>
              @if (selectedItemId() === item.id) {
                <img class="check-circle-icon" src="assets/icons/check-circle.svg" alt="" />
              }
            </button>
          }
        </div>
      }
    }
  </ng-container>

  <ng-container slot="modal-footer">
    <mbp-button data-testid="cancel-select-item-btn" type="secondary" [text]="'general.cancel' | translate"
      [disabled]="processing()" (buttonClick)="onClose()"></mbp-button>
    <mbp-button data-testid="save-select-item-btn" data-modal-primary type="primary" [text]="labels().saveButtonText"
      [disabled]="!selectedItem() || processing()" (buttonClick)="onSave()"></mbp-button>
  </ng-container>
</mbp-modal>
